<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">Product Categories</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="category in categories" :key="category.id" :item="category" :nextLink="'/category/' + category.id + '/products'"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import Category from '@/models/Category'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Categories',
  components: {
    ItemCard
  },
  data () {
    return {
      categories: null
    }
  },
  mounted () {
    this.fetchCategories()
  },
  methods: {
    fetchCategories () {
      this.categories = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchCategories')
        .then((result) => {
          result.data.categories.forEach(category => {
            this.categories.push(new Category(category))
          })
          $('.overlay').addClass('d-none')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Categories.vue